import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    tabletWebContainer: {
        flex: 1
    },
    mobileContainer: {
        width: '100%',
        justifyContent: 'center',
        flex: 1
    },
    container: {
        flex: 1,
        alignSelf: 'stretch',
        alignItems: 'center',
        backgroundColor: Theme.primaryBackgroundColor,
        paddingBottom: 20,
        marginHorizontal: Theme.primaryMargin
    },
    titleContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center'
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: 25,
        marginBottom: 10,
        color: Theme.primaryTextColor
    },
    infoBox: {
        marginTop: 20
    },
    innerContainer: {
        flex: 1,
        // alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginTop: -50
    },
    input: {
        fontFamily: Theme.regularFont,
        alignSelf: 'stretch',
        backgroundColor: '#FFFFFF',
        fontSize: 21,
        color: '#333333',
        height: 55,
        borderRadius: 3,
        paddingHorizontal: 12
    },
    firstInput: {
        marginTop: 22,
        marginBottom: 14
    },
    inputContainerItem: {
        marginBottom: 14
    },
    rememberPassContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignSelf: 'stretch',
        marginBottom: 18,
        marginTop: 4,
        maxWidth: '90%'
    },
    rememberPassText: {
        color: '#ffffff',
        marginLeft: 12,
        fontFamily: Theme.regularFont,
        fontSize: 18
    },
    forgottenPassText: {
        fontSize: 18
    },
    forgottenUsernameText: {
        fontSize: 18,
        paddinTop: 10,
        marginBottom: Device.isPhone ? 10 : null,
        marginTop: 10
    },
    buttonsContainer: {
        marginTop: 20,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center'
    },
    buttonContainerOneButton: {},
    checkbox: {
        zIndex: 1
    },
    modalHeaderIconContainer: {
        zIndex: 1000,
        marginTop: Device.isIos ? 40 : 15
    },
    button: {},
    loginButton: {},
    info: {
        marginTop: 20,
        width: 25,
        height: 25,
        alignSelf: 'center',
        color: Theme.primaryActiveColor
    },
    switchContainer: {
        position: 'absolute',
        right: 20,
        height: '100%',
        width: 30,
        top: -5,
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputContainer: {
        alignSelf: 'stretch',
        marginBottom: 14
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            ...baseStyles.container,
            marginHorizontal: Device.isWeb ? 0 : Theme.primaryMargin
        },
        innerContainer: {
            ...baseStyles.innerContainer,
            ...(Device.isTabletOrWeb && {
                width: 500,
                alignSelf: 'center'
            }),
            marginHorizontal: '22%',
            marginTop: 0
        },
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            flexDirection: 'row-reverse',
            justifyContent: 'space-around'
        },
        buttonContainerOneButton: {
            marginHorizontal: '22%'
        },
        forgottenUsernameText: {
            ...baseStyles.forgottenUsernameText,
            fontSize: 20
        },
        forgottenPassText: {
            marginTop: 20
        },
        button: {
            ...baseStyles.button,
            marginHorizontal: Theme.BU,
            flex: 2
        },
        loginButton: {
            ...baseStyles.loginButton,
            flex: 10
        },
        title: {
            ...baseStyles.title,
            fontSize: 30
        },
        modalHeaderIconContainer: {
            marginTop: 30
        }
    };
}

export default StyleSheet.create(baseStyles);
